import { useState } from 'react';
import { mediaAPI } from '../utils/apiClient';

export const useMediaUpload = () => {
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);

  const uploadMedia = async (file) => {
    setUploading(true);
    setUploadError(null);
    
    try {
      const response = await mediaAPI.uploadMedia(file);
      return response;
    } catch (error) {
      setUploadError(error);
      throw error;
    } finally {
      setUploading(false);
    }
  };

  return {
    uploading,
    uploadError,
    uploadMedia
  };
};